import React, { useState } from 'react';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Tab, { TabGroup } from '@amzn/meridian/tab';
import { useTranslation } from 'src/arb-wrapper';
import { useDocumentTitle } from 'src/hooks/useDocumentTitle';
import { SpotlightJobCreationForm } from 'src/components/spotlight/SpotlightJobCreationForm';
import { SpotlightJobHistory } from 'src/components/spotlight/SpotlightJobHistory';
import { useGetSpotlightJobHistoryQuery } from 'src/store/spotlight-api';

type SpotlightTab = 'JOB_CREATION' | 'JOB_HISTORY';

export const SpotlightLalAudienceCreation = () => {
  useDocumentTitle('Spotlight LAL Audience Creation');
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<SpotlightTab>('JOB_CREATION');

  const { data, isLoading, isError } = useGetSpotlightJobHistoryQuery();

  return (
    <Column alignmentHorizontal="stretch" spacing="400">
      <Heading level={1}>{t('spotlight_lal')}</Heading>
      <TabGroup data-testid="spotlight-tab-menu" fill="line" value={activeTab} onChange={setActiveTab}>
        <Tab data-testid="spotlight-tab-job-creation" value="JOB_CREATION">
          {t('spotlight_tab_create_job')}
        </Tab>
        <Tab data-testid="spotlight-tab-job-history" value="JOB_HISTORY">
          {t('spotlight_tab_job_history')}
        </Tab>
      </TabGroup>
      {activeTab === 'JOB_CREATION' && <SpotlightJobCreationForm />}
      {activeTab === 'JOB_HISTORY' && (
        <SpotlightJobHistory
          data={data}
          isError={isError}
          isLoading={isLoading}
        />
      )}
    </Column>
  );
};
